import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/outbound");

export const Route = createFileRoute("/outbound/")({
  head: () => ({
    meta: [
      { title: "Outbound channels — LevelLoad" },
      { name: "description", content: "Outbound channels — LevelLoad transport planning." },
      { property: "og:title", content: "Outbound channels — LevelLoad" },
      { property: "og:description", content: "Outbound channels — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
